"use client";

import { About } from "@/components/about";
import TsParticlesBackground from "@/components/animation/particles/TsParticlesBackground";
import { StarsCanvas } from "@/components/canvas";
import { ChatbotWidget } from "@/components/chatbot/chatbot-widget";
import { AnimatedSection } from "@/components/common/animated-section";
import { Contact } from "@/components/contact";
import ExperienceTimeline from "@/components/experience/experience-timeline";
import { FooterSection } from "@/components/mouheb/footer-section";
import { Newsletter } from "@/components/newsletter";
import { Projects } from "@/components/projects";
import { SkillsComponent } from "@/components/skills/skills";
import { Separator } from "@/components/ui/separator";
import HeroSection from "@/components/welcome/hero-section";
// import SVGLogoParticles from "@/components/animation/new/svg-logo-particles";
// import { CSSNetworkBackground } from "@/components/animation/new/CssParticlesBackground";

export default function Home() {
  return (
    <main className="w-full min-h-screen overflow-hidden bg-gray-200 dark:bg-black">
      {/* Smooth Scroll Provider */}

      {/* <HomePageAnimation /> */}
      {/* <SectionsTransition /> */}
      {/* <ThreeScene /> */}
      {/* <ParticleFollowMouse /> */}

      {/* TS Particles Background - only on top screen with mouse interaction */}
      <TsParticlesBackground />

      {/* <ParticlesNewBackground
        particleCount={60}
        colors={["#ff6b6b", "#4ecdc4", "#45b7d1", "#f9ca24", "#f0932b"]}
        maxRadius={4}
        speed={0.8}
      /> */}

      {/* Main Content Sections */}
      <div className="z-10 flex-1 flex flex-col items-center gap-2">
        {/* bg-background px-8 lg:px-16 */}
        {/* <SmoothScroll /> */}
        {/* <HeroScene /> */}
        {/* <WelcomeSection /> */}
        <HeroSection />

        <Separator className="bg-purple-800 dark:bg-white mx-auto max-w-3xl mb-4" />

        <AnimatedSection>
          <About />
        </AnimatedSection>

        <Separator className="bg-purple-800 dark:bg-white mx-auto max-w-3xl mb-4" />

        {/* threshold={0.15} className="relative mx-auto px-4 sm:px-6 lg:px-8" */}
        <AnimatedSection>
          <SkillsComponent />
        </AnimatedSection>

        <Separator className="bg-purple-800 dark:bg-white mx-auto max-w-3xl mb-4" />

        <AnimatedSection>
          {/* <Experience /> */}
          <ExperienceTimeline />
        </AnimatedSection>

        <Separator className="bg-purple-800 dark:bg-white mx-auto max-w-3xl mb-4" />

        <Projects />

        <Separator className="bg-purple-800 dark:bg-white mx-auto max-w-3xl mb-4" />

        <AnimatedSection>
          <Newsletter />
        </AnimatedSection>

        <Separator className="bg-purple-800 dark:bg-white mx-auto max-w-3xl mb-4" />

        <AnimatedSection>
          <Contact />
        </AnimatedSection>

        <div className="relative z-0">
          <StarsCanvas />
        </div>

        <FooterSection />
      </div>

      <ChatbotWidget />
    </main>
  );
}
